import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MdCalendarToday, MdClear, MdFilterAlt } from "react-icons/md";
import {
  getCleaningData,
  getCurrentLocalDateTime,
} from "../utils/helperFunctions";
import { format } from "date-fns";

const RoomcleaningData = () => {
  const [cleaningData, setCleaningData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    roomNumber: "",
    date: "",
  });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [totalduration, setTotalduration] = useState("00:00");
  const { date } = getCurrentLocalDateTime();
  

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({
      roomNumber: "",
      date: "",
    });
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [filters]);

  useEffect(() => {
    fetchCleaningData();
  }, [debouncedFilters]);

  const fetchCleaningData = async () => {
    try {
      setIsLoading(true);
      const params = {
        ...(debouncedFilters.roomNumber.trim() && {
          roomNumber: debouncedFilters.roomNumber,
        }),
        ...(debouncedFilters.date.trim() && { date: debouncedFilters.date }),
      };
      const response = await getCleaningData(params);
      if (response.data.status) {
        setCleaningData(response.data.data);
        setTotalduration(response.data.totalDuration);
      }
    } catch (error) {
      console.error("Error fetching rooms:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 md:p-6 bg-gray-50 ">
      <div className="container mx-auto mb-6 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl shadow-sm overflow-hidden">
        <div className="p-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                Room Cleaning
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                Manage all room cleaning timing and calculation
              </p>
            </div>
            <button
              onClick={() => {
                setShowFilters(!showFilters);
                resetFilters();
              }}
              className="flex items-center gap-2 px-4 py-2 bg-white text-indigo-600 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors shadow-sm"
            >
              {showFilters ? (
                <MdClear className="text-lg" />
              ) : (
                <MdFilterAlt className="text-lg" />
              )}
              {showFilters ? "Hide Filters" : "Filters"}
            </button>
          </div>
          {/* Filters Section */}
          {showFilters && (
            <motion.div
              initial={{ opacity: 0, height: "auto" }}
              animate={{ opacity: 1, height: "auto" }}
              transition={{ duration: 0.3 }}
              className="bg-white p-6 rounded-lg shadow-sm border border-indigo-300 "
            >
              <div className="flex justify-end mb-4">
                {Object.values(filters).some(
                  (val) => val !== "" && val !== null
                ) && (
                  <button
                    onClick={resetFilters}
                    className="flex items-center gap-1 text-sm text-indigo-600 hover:text-indigo-800"
                  >
                    <MdClear className="text-lg" />
                    Clear all
                  </button>
                )}
              </div>

              <div className="grid grid-cols-1  md:grid-cols-2  gap-4">
                <div className="space-y-1">
                  <label className="block text-sm font-medium text-indigo-500">
                    Room Number
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="roomNumber"
                      value={filters.roomNumber}
                      onChange={handleFilterChange}
                      placeholder="Enter room no."
                      className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 text-sm"
                    />
                  </div>
                </div>
                <div className="space-y-1 relative">
                  <label className="block text-sm font-medium text-indigo-500">
                    Date
                  </label>
                  <div className="relative w-full">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-20">
                      <MdCalendarToday className="text-gray-400" />
                    </div>
                    <input
                      type="text"
                      readOnly
                      placeholder="DD/MM/YYYY"
                      value={
                        filters.date
                          ? format(new Date(filters.date), "dd/MM/yyyy")
                          : ""
                      }
                      onClick={() =>
                        document.getElementById("date-date-picker").showPicker()
                      }
                      className="absolute top-0 left-0 w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white text-black cursor-pointer focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm z-10"
                    />
                    <input
                      type="date"
                      id="date-date-picker"
                      name="date"
                      max={date}
                      value={filters.date}
                      onChange={handleFilterChange}
                      className="w-full pl-10 pr-3 py-1.5 border border-gray-300 rounded-md shadow-sm bg-transparent text-transparent caret-transparent z-0 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                    />
                  </div>
                </div>
              </div>
            </motion.div>
          )}
        </div>

        <div className=" mx-auto bg-white shadow-sm overflow-hidden">
          <div className="p-4 md:p-6">
            {isLoading && cleaningData.length === 0 ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
              </div>
            ) : cleaningData.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12">
                <p className="mt-4 text-lg font-medium text-gray-500">
                  No cleaning data found
                </p>
              </div>
            ) : (
              <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-md">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gradient-to-r from-indigo-50 to-blue-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Room No
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Start Time
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        End Time
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Duration
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {cleaningData.map((room, index) => (
                      <motion.tr
                        key={room._id}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className={`transition-colors duration-150 ${
                          index % 2 === 0 ? "bg-white" : "bg-indigo-50/30"
                        } hover:bg-indigo-100/30`}
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {room.roomNumber.roomNo}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {new Date(room.startTime)
                            .toLocaleDateString("en-GB", {})
                            .replace(/\//g, "-")}{" "}
                          {new Date(room.startTime).toLocaleTimeString(
                            "en-US",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )}
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {room.endTime ? (
                            <>
                              {new Date(room.endTime)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, "-")}{" "}
                              {new Date(room.endTime).toLocaleTimeString(
                                "en-US",
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                }
                              )}
                            </>
                          ) : (
                            "Ongoing"
                          )}
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {room.duration}
                        </td>
                      </motion.tr>
                    ))}
                  </tbody>
                  {/* Total Duration Row */}
                  <tfoot className="bg-indigo-100">
                    <tr>
                      <td
                        colSpan="3"
                        className="px-6 py-3 text-right text-sm font-bold text-indigo-800"
                      >
                        Total Cleaning Duration:
                      </td>
                      <td className="px-6 py-3 text-sm font-bold text-indigo-800">
                        {totalduration}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomcleaningData;